export const CROP_ZONE_TAGS_FIELD = 'tagIds';

export const CROP_ZONE_TAGS_COLUMNS = 2;
